<script lang="ts" generic="TItem" setup>
import Card from '../utils/Card.vue';
import type { Header } from '../helpers';

interface Props
{
    showHeader: boolean;
    headers: Header[];
    rows: TItem[];
    pager: Pager;
}

defineOptions({
    name: 'ListViewCardLayout',
    inheritAttrs: false
});

const props = withDefaults(defineProps<Props>(), {});
const loaded = inject<boolean>('loaded');
const emptyLabel = inject<string>('empty-label');
const $attrs = useAttrs();
const attrs = (): Record<string, any> => only($attrs, 'class', 'style');

const items = computed(() =>
{
    if (loaded)
        return props.rows;

    return [];
});
</script>

<template>
    <div v-bind="attrs()">
        <template v-if="loaded">
            <Card v-for="(item, index) in items" :key="`row-${index}`" :index="index" :item="item">
                <slot name="row" :item="item" :index="index" />
            </Card>
            <div v-if="items.length == 0">
                <div class="text-center p-3 mt-1 mb-3 bg-body-tertiary">
                    {{ $t(emptyLabel) }}
                </div>
            </div>
        </template>
    </div>
</template>
